import React from 'react'
import { SectionHeader, SectionWrap, ButtonSecoundry } from '../../Components';
import FieldsShort from '../FieldsShort/FieldsShort';
import './Taxes.css';
import { useTranslation } from 'react-i18next';


function Taxes() {
  const { t, i18n } = useTranslation();
  
  return (
    <>
    <div className='fieldsPageContainer'>
        <div className='headPage taxes'>
        </div>
        <div className='containerNew'>
          <SectionWrap>
            <SectionHeader title={t('fieldsShort6')} disc={t('fieldsPageSpan')} />
            <div className='fieldInfo'>
            <span>{t('foeldsPage6Span1')}</span>
            <p>{t('fieldsPage6p1')}</p>
            <span>{t('foeldsPage6Span2')}</span>
            <p>{t('fieldsPage6p2')}</p>
                <ul className='listProperty'>
                  <li>{t('fieldsPage6Li1')}</li>
                  <li>{t('fieldsPage6Li2')}</li>
                  <li>{t('fieldsPage6Li3')}</li>
                  <li>{t('fieldsPage6Li4')}</li>                    
                </ul>
                <span>{t('foeldsPage6Span3')}</span>
                <p>{t('fieldsPage6p3')}</p>
                <span>{t('foeldsPage6Span4')}</span>
                <p>{t('fieldsPage6p4')}</p>
                <p>{t('fieldsPage6p5')}</p>
                </div>
            <ButtonSecoundry className='askBtnFields' href='/askConsults'>{t('askYourConsult')}</ButtonSecoundry>
        </SectionWrap>
        </div>
        <FieldsShort />
    </div>
    </>
  )
}

export default Taxes